import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  MatIconModule,
  MatButtonModule,
  MatSelectModule,
  MatOptionModule,
  MatTooltipModule,
  MatFormFieldModule,
  MatDialogModule,
  MatInputModule
} from '@angular/material';

import { IgoLanguageModule } from '@ximple/igo2-core';
import { IgoConfirmDialogModule, IgoStopPropagationModule } from '@ximple/igo2-common';
import { IgoAuthModule } from '@ximple/igo2-auth';

import { BookmarkButtonComponent } from './bookmark-button/bookmark-button.component';
import { BookmarkDialogComponent } from './bookmark-button/bookmark-dialog.component';
import { PoiButtonComponent } from './poi-button/poi-button.component';
import { PoiDialogComponent } from './poi-button/poi-dialog.component';
import { PoiService } from './poi-button/shared/poi.service';
import { UserDialogComponent } from './user-button/user-dialog.component';
import { UserButtonComponent } from './user-button/user-button.component';

@NgModule({
  imports: [
    CommonModule,
    IgoLanguageModule,
    IgoConfirmDialogModule,
    IgoStopPropagationModule,
    IgoAuthModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule
  ],
  exports: [BookmarkButtonComponent, PoiButtonComponent, UserButtonComponent],
  declarations: [
    BookmarkButtonComponent,
    BookmarkDialogComponent,
    PoiButtonComponent,
    PoiDialogComponent,
    UserButtonComponent,
    UserDialogComponent
  ],
  entryComponents: [
    BookmarkDialogComponent,
    PoiDialogComponent,
    UserDialogComponent
  ],
  providers: [PoiService]
})
export class IgoContextMapButtonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IgoContextMapButtonModule
    };
  }
}
